export const LeadTypes = {
  MY_LEAD: "my_lead",
  PRE_ASSIGN_LEAD: "pre_assign_lead",
  REVIEW_LEAD: "review_lead",
  ASSIGN_LEAD: "assign_lead",
  MY_ASSIGN_LEAD: "my_assign_lead",
};
